import React, { useState } from 'react';
import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

import T from '@prisjakt/ui-translate';

const ToggleText = styled.button`
  color: ${p => p.theme.text.callToAction};
  cursor: pointer;
  text-align: left;
  width: max-content;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

const LINE_HEIGHT = layout.lineHeight;

type StyledProps = {
  showAll: boolean;
  fontSize: string;
  lineCount: number;
};

const TextBlock = styled.div<StyledProps>`
  position: relative;
  overflow: hidden;
  font-size: ${p => p.fontSize};
  line-height: ${LINE_HEIGHT};
  max-height: ${p =>
    p.showAll
      ? '100%'
      : `calc((${p.fontSize} * ${LINE_HEIGHT}) * ${p.lineCount})`};

  p {
    line-height: inherit;
    font-size: inherit;
    margin-bottom: ${p => `calc(${p.fontSize} * ${LINE_HEIGHT})`};
  }

  &::before {
    content: ${p => (p.showAll ? '' : '"..."')};
    position: absolute;
    bottom: 0;
    right: 0;
    background: ${p => p.theme.bg.primary};
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    width: 1rem;
    height: 1rem;
    background: ${p => p.theme.bg.primary};
  }
`;

type Props = {
  text: string;
  fontSize?: string;
  lineCount?: number;
  onExpand?: () => void;
};

const Text = ({
  text,
  lineCount = 4,
  fontSize = layout.measurements.fontSizeNormal,
  onExpand = () => {},
}: Props) => {
  const [showText, setShowText] = useState(false);

  const toggleExpand = () => {
    if (!showText) {
      onExpand();
    }

    setShowText(!showText);
  };

  return (
    <>
      <TextBlock
        dangerouslySetInnerHTML={{ __html: text }}
        showAll={showText}
        lineCount={lineCount}
        fontSize={fontSize}
      />

      <ToggleText type="button" onClick={toggleExpand}>
        {showText ? (
          <T domain="common">button.show-less</T>
        ) : (
          <T domain="common">button.show-more</T>
        )}
      </ToggleText>
    </>
  );
};

export default Text;
